module.exports = __webpack_public_path__ + "static/img/M2-S-211-1.52553c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/module2/M2-S-211-1.png
// module id = 576
// module chunks = 0